/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/video-editor-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/video-editor-api-client";
import type { ProjectsDeleteMutationResponse, ProjectsDeletePathParams } from "../models/ProjectsDelete";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { projectsDelete } from "../axios/projectsDelete";
import { useMutation } from "@tanstack/react-query";

export const projectsDeleteMutationKey = () => ["video-editor-api", { url: '/projects/:id' }] as const

export type ProjectsDeleteMutationKey = ReturnType<typeof projectsDeleteMutationKey>

/**
 * @summary Delete a project
 * {@link /projects/:id}
 */
export function useProjectsDelete<TContext>(options: 
{
  mutation?: UseMutationOptions<ProjectsDeleteMutationResponse, ResponseErrorConfig<Error>, {id: ProjectsDeletePathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? projectsDeleteMutationKey()

  return useMutation<ProjectsDeleteMutationResponse, ResponseErrorConfig<Error>, {id: ProjectsDeletePathParams["id"]}, TContext>({
    mutationFn: async({ id }) => {
      return projectsDelete(id, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}